import { render } from "./WelcomeHome.vue?vue&type=template&id=5c66704c&scoped=true"
const script = {}

import "./WelcomeHome.vue?vue&type=style&index=0&id=5c66704c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c66704c"]])

export default __exports__